import { ThunkAction } from 'redux-thunk';

import _flatMap from 'lodash-es/flatMap';

import * as CatalogClient from 'Clients/Catalog';
import RootState from 'Store/Root';
import { YarnSpriteItem } from 'Types/Yarns';
import { Yarns } from 'Types';
import { Urls as ImageUrls } from 'Clients/Images';

export const LOADING_COLORFAVORITES = 'LOADING_COLORFAVORITES';
export const LOADED_COLORFAVORITES = 'LOADED_COLORFAVORITES';
export const LOAD_COLORFAVORITES_FAILED = 'LOAD_COLORFAVORITES_FAILED';
export const SET_COLORFAVORITES = 'SET_COLORFAVORITES';

export interface ColorFavoritesAction {
  type: string;
  items?: YarnSpriteItem[];
}

function loadingColorFavorites(): ColorFavoritesAction {
  return {
    type: LOADING_COLORFAVORITES
  };
}

function colorFavoritesLoadFailed(): ColorFavoritesAction {
  return {
    type: LOAD_COLORFAVORITES_FAILED
  };
}

function colorFavoritesLoaded(items: YarnSpriteItem[]): ColorFavoritesAction {
  return {
    type: LOADED_COLORFAVORITES,
    items: items
  };
}

export function loadColorFavorites(): ThunkAction<Promise<any>, RootState, any> {
  return (dispatch, getState) => {
    const state = getState();

    if (!state.user.status.loggedIn) {
      return Promise.resolve(true);
    }

    if (state.colorFavorites.loaded || state.colorFavorites.loading) {
      return Promise.resolve(true);
    }

    dispatch(loadingColorFavorites());

    return Promise.all([
      CatalogClient.ColorFavorites.getColorFavorites(),
    ]).then(
      x => dispatch(colorFavoritesLoaded(mapColorFavoritesToYarnSpriteItem(x[0], state.yarnLibraries.items))),
      e => dispatch(colorFavoritesLoadFailed())
    );
  };
}

function mapColorFavoritesToYarnSpriteItem(colorFavorites: TrykApi.Catalog.IColorFavorites, libs: TrykApi.Yarns.IYarnLibrary[], size = 15): YarnSpriteItem[] {

  if (!colorFavorites || !colorFavorites.yarns || colorFavorites.yarns.length === 0) {
    return [];
  }

  const yarns = _flatMap(libs.map(lib =>
    lib.yarns.map<YarnSpriteItem>(yarn => {
      const thumbnailUrl = 'url(' + ImageUrls.Thumbnail.yarn(yarn.code, '', yarn.masterLibraryCode, size) + ')';

      return {
        id: yarn.yarnId,
        typeId: yarn.yarnTypeId,
        code: yarn.code,
        label: yarn.code,
        childCodes: yarn.constructions.map(constr => constr.child.code),
        isHighLuster: yarn.properties.isHighLustre,
        background: thumbnailUrl,
      };
    })
  ));

  return colorFavorites.yarns
    .sort((a, b) => { return a.slot - b.slot; })
    .map(x => {
      const result = yarns.find(yarn => yarn.id === x.yarnId);

      if (result === undefined) {
        return {
          id: 0,
          typeId: 0,
          code: '',
          label: '',
          childCodes: [],
          isHighLuster: false,
          background: '',
        };
      }

      return result;
    });
}

export function saveColorFavorites(
  colorFavorites: Yarns.YarnSpriteItem[]
): ThunkAction<Promise<boolean>, RootState, any> {
  return (dispatch, getState) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch<ColorFavoritesAction>({
        type: SET_COLORFAVORITES,
        items: colorFavorites
      });

      updateColorFavorites(getState());

      resolve(true);
    });
  };
}

function updateColorFavorites(state: RootState) {
  const colorFavorites = {
    colorFavoritesId: 0,
    siteId: 0,
    userId: 0,
    yarns: state.colorFavorites.items.map<TrykApi.Catalog.IColorFavoritesYarns>(
      (x, idx) => {
        return {
          colorFavoritesYarnsId: 0,
          colorFavoritesId: 0,
          yarnId: x.id,
          slot: idx,
        };
      }
    ),
  };

  CatalogClient.ColorFavorites.saveColorFavorites(colorFavorites);
}
